
import React, { Component } from "react";
import {Icon, Rate} from 'antd'


import {  Link } from "react-router-dom"


class OrderListView extends Component {

    constructor(props) {
        super(props)
        this.location = {
            "resort_name": "253 Mancreek Resort",
            "address_line1": " 253 scottland av",
            "county": "albanyt",
            "postalcode": 12193,
            "market_code": "NAMER",
            "country": "usa",
            "region_desc_en": [
                "United States",
                "Coastal Mid Atlantic"
            ],
            "state": "NY",
        }
    }
    render() {
        const ars = [];
        let svrstars = {
            "sv_rating_no": 5,
            "color": "#e8a01899"
        }
        console.log('############### this.props.svrlocation ****************')
        console.log(this.props.svrlocation)






        return (

      
        
          
              
                <p className="m-para-text-first" style={{paddingTop:"10px"}}>
                    <span> 
                        <text className="svr-hotel-name"  style={{fontSize:"1.5.em", paddingRight:"10px",color:"rgb(208,156,31)"}}>{this.props.svrlocation.resort_name}</text>
        
                        <Icon  style={{ color:"rgb(215, 125, 10)" , fontSize:"20px" }} type="slack-square" theme="filled" />
                    </span>
                    
                    <span className="ter-l2 svr-hotel-location" style={{marginTop:"0px", marginBottom:"0px"}}>
                        <text style={{fontSize:"15px", color:"rgb(132, 115, 97)", fontWeight:"400", paddingRight:"15px"}}>
                        SV7{this.props.svrlocation.address_line1}, {this.props.svrlocation.county}, {this.props.svrlocation.postalcode} , {this.props.svrlocation.country} 
                        </text>
                        <Icon  style={{ color: "rgb(7, 115, 29)", fontSize:"20px" }} type="environment" theme="filled" />
                        <text style={{fontSize:"16px", color:"rgb(18, 85, 219)", paddingLeft:"10px",fontWeight:"420"}}>Excellent2 {this.props.svrlocation['space_key']}- Shown On Map</text> 
                    </span>
                        
                    <span style={{fontSize: "12px"}} style={{marginTop:"0px",display:"block", marginBottom:"0px"}} > 
                       
                        <text style={{fontSize:"12px", color:"rgb(129, 133, 142)",paddingRight:"10px", paddingLeft:"0px",fontWeight:"400"}}> {this.props.svrlocation.num_reviews} reviews</text>
                        <Icon  style={{ fontSize:"14px",color: '#eb2f96' }} type="car" theme="filled" />
                        <text style={{fontSize:"12px", color:"rgb(129, 133, 142)", paddingLeft:"10px",paddingRight:"10px",fontWeight:"420"}}>{this.props.svrlocation.nearest_airport_distance_mi_lvl}  miles from {this.props.svrlocation.en_nearest_airports_lvl} Airport</text>
                   
                        <Icon  style={{fontSize:"14px", color: '#eb2f96' }} type="dingtalk-square" theme="filled" />
                        <text style={{fontSize:"16px", color:"rgb(18, 85, 219)", paddingLeft:"10px",fontWeight:"420"}}>HoteSV Website</text>
                    </span>
                    
                    <p>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Stay(StartDate-EndDate)</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">{this.props.svrprice.startDateStay}- {this.props.svrprice.endDateStay}</span> </dd>
                        </dl>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Order Status</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">{this.props.svrprice.orderItemStatusCodeDesc}</span> </dd>
                        </dl>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Order Date</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">10/20/2023 7:56;23 AM</span> </dd>
                        </dl>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Order Id</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2"> {this.props.svrprice.orderId}</span> </dd>
                        </dl>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Customer Id</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2"> {this.props.svrprice.customerId}</span> </dd>
                        </dl>
                    
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Address Id</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2"> {this.props.svrprice.addressId}</span> </dd>
                        </dl>

                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Room Mates</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2"> 2 Adults </span> </dd>
                        </dl>
                    
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Rservation Code</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">{this.props.svrprice.reservationConfirmCode}</span> </dd>
                        </dl>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Order Total</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">{this.props.svrprice.totalWithCurrency}</span> </dd>
                        </dl>
                    </p>
                </p>
                

          
        )
    }

}

export default OrderListView;